export const getEmptyLocationValues = () => {
  return {
    city: null,
    zip: null,
    street: "",
    street_number: ""
  }
}

/**
 * @param {{city?: string}[]} [locations]
 * @returns {string} comma-separated city names
 */
export const joinCities = (locations) =>
  (locations ?? [])
    .map((location) => location.city)
    .filter(Boolean)
    .join(", ")
